import { render } from "./BannerList.vue?vue&type=template&id=868a8e04&scoped=true&ts=true"
import script from "./BannerList.vue?vue&type=script&lang=ts"
export * from "./BannerList.vue?vue&type=script&lang=ts"

import "./BannerList.vue?vue&type=style&index=0&id=868a8e04&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868a8e04"]])

export default __exports__